import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const usePreQuoteTypeReducer = () =>
  useSelector((state: ApplicationState) => state.preQuoteType);
